/**
 * Valumize Algorithmic DMV API
 * Batch-run the algorithmic discount-multiple valuation across many holdings of a fund within the context of a specific Bottom-Up fund valuation. Mirrors the single-asset \"fox button\" calculation but scales it across a fund. Generated results are staged for user review and only written back to AssetValuation when the user explicitly accepts each one. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AlgorithmicDmvAlgorithmStatus = 'PENDING' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED' | 'INELIGIBLE';

export const AlgorithmicDmvAlgorithmStatus = {
    Pending: 'PENDING' as AlgorithmicDmvAlgorithmStatus,
    InProgress: 'IN_PROGRESS' as AlgorithmicDmvAlgorithmStatus,
    Success: 'SUCCESS' as AlgorithmicDmvAlgorithmStatus,
    Failed: 'FAILED' as AlgorithmicDmvAlgorithmStatus,
    Ineligible: 'INELIGIBLE' as AlgorithmicDmvAlgorithmStatus
};

